var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 467;
var h = 467;
var nm = "Target  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 3,
        nm: "TailRig",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    -243.014,
                    -289.986,
                    0
                ],
                ix: 2,
                l: 2,
                x: "var $bm_rt;\nvar srcLayer = thisComp.layer('arrow');\nvar srcPath = srcLayer('ADBE Root Vectors Group')(1)('ADBE Vector Shape').points()[0];\n$bm_rt = srcLayer.toComp(srcPath);"
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ip: 5.00000020365417,
        op: 905.000036861406,
        st: 5.00000020365417,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Fadeoutfill",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    233,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                1,
                                1,
                                1,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 1.00000004073083,
        op: 902.000036739213,
        st: 2.00000008146167,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "tail",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    258,
                    211,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    217.475,
                    250.876,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ],
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ]
                        ],
                        v: [
                            [
                                420.5,
                                271.5
                            ],
                            [
                                190.5,
                                501.5
                            ],
                            [
                                -39.5,
                                271.5
                            ],
                            [
                                190.5,
                                41.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -2.3,
                                        -41.026
                                    ],
                                    [
                                        8.178,
                                        -8.178
                                    ],
                                    [
                                        41.026,
                                        2.3
                                    ],
                                    [
                                        2.3,
                                        41.026
                                    ],
                                    [
                                        -39.275,
                                        39.275
                                    ],
                                    [
                                        -41.026,
                                        -2.3
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.976470589638,
                                0.654901981354,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.96862745285,
                                0.921568632126,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('TailRig').transform.position;"
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 5.00000020365417,
        op: 905.000036861406,
        st: 5.00000020365417,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "arrow",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233.75,
                    234.601,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                -127.025
                            ],
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.025,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                127.026,
                                0
                            ]
                        ],
                        v: [
                            [
                                230.5,
                                0.5
                            ],
                            [
                                0.5,
                                230.5
                            ],
                            [
                                -229.5,
                                0.5
                            ],
                            [
                                0.5,
                                -229.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: 0.387,
                                y: 1
                            },
                            o: {
                                x: 1,
                                y: 0
                            },
                            t: 6,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            181.661,
                                            -181.31
                                        ],
                                        [
                                            179.94,
                                            -180.089
                                        ]
                                    ],
                                    c: false
                                }
                            ]
                        },
                        {
                            i: {
                                x: 0.138,
                                y: 1
                            },
                            o: {
                                x: 0.591,
                                y: 0
                            },
                            t: 10,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            161.661,
                                            -161.31
                                        ],
                                        [
                                            -22.986,
                                            22.986
                                        ]
                                    ],
                                    c: false
                                }
                            ]
                        },
                        {
                            t: 13.0000005295009,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            22.986,
                                            -22.986
                                        ],
                                        [
                                            -22.986,
                                            22.986
                                        ]
                                    ],
                                    c: false
                                }
                            ]
                        }
                    ],
                    ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.976470589638,
                        0.654901981354,
                        0.46274510026,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.167,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            }
        ],
        ip: 5.00000020365417,
        op: 905.000036861406,
        st: 5.00000020365417,
        bm: 0
    },
    {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "lil circle",
        sr: 0.99444444444444,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    212.167,
                    255.084,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -20.741,
                                        0
                                    ],
                                    [
                                        0,
                                        -20.741
                                    ],
                                    [
                                        20.741,
                                        0
                                    ],
                                    [
                                        0,
                                        20.741
                                    ]
                                ],
                                o: [
                                    [
                                        20.741,
                                        0
                                    ],
                                    [
                                        0,
                                        20.741
                                    ],
                                    [
                                        -20.741,
                                        0
                                    ],
                                    [
                                        0,
                                        -20.741
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -37.555
                                    ],
                                    [
                                        37.555,
                                        0
                                    ],
                                    [
                                        0,
                                        37.555
                                    ],
                                    [
                                        -37.555,
                                        0
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.533,
                                            0.533
                                        ],
                                        y: [
                                            1,
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.938,
                                            0.938
                                        ],
                                        y: [
                                            0.001,
                                            0.001
                                        ]
                                    },
                                    t: 5.001,
                                    s: [
                                        0,
                                        0
                                    ]
                                },
                                {
                                    i: {
                                        x: [
                                            0,
                                            0
                                        ],
                                        y: [
                                            1.005,
                                            1.005
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.966,
                                            0.966
                                        ],
                                        y: [
                                            -0.025,
                                            -0.025
                                        ]
                                    },
                                    t: 8,
                                    s: [
                                        120,
                                        120
                                    ]
                                },
                                {
                                    t: 10.0101740188338,
                                    s: [
                                        100,
                                        100
                                    ]
                                }
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.976470589638,
                        0.654901981354,
                        0.46274510026,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.167,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            },
            {
                ty: "fl",
                c: {
                    a: 0,
                    k: [
                        1,
                        0.96862745285,
                        0.921568632126,
                        1
                    ],
                    ix: 4,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                bm: 0,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
            }
        ],
        ip: 5.00000020365417,
        op: 899.000036617021,
        st: 4.00000016292334,
        bm: 0
    },
    {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "big circle",
        sr: 0.99222222222222,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    212.167,
                    255.084,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -44.139,
                                        0
                                    ],
                                    [
                                        0,
                                        -44.139
                                    ],
                                    [
                                        44.139,
                                        0
                                    ],
                                    [
                                        0,
                                        44.139
                                    ]
                                ],
                                o: [
                                    [
                                        44.139,
                                        0
                                    ],
                                    [
                                        0,
                                        44.139
                                    ],
                                    [
                                        -44.139,
                                        0
                                    ],
                                    [
                                        0,
                                        -44.139
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -79.92
                                    ],
                                    [
                                        79.92,
                                        0
                                    ],
                                    [
                                        0,
                                        79.92
                                    ],
                                    [
                                        -79.92,
                                        0
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.567,
                                            0.567
                                        ],
                                        y: [
                                            1,
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.786,
                                            0.786
                                        ],
                                        y: [
                                            0.001,
                                            0.001
                                        ]
                                    },
                                    t: 7.001,
                                    s: [
                                        0,
                                        0
                                    ]
                                },
                                {
                                    i: {
                                        x: [
                                            0,
                                            0
                                        ],
                                        y: [
                                            1.005,
                                            1.005
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.973,
                                            0.973
                                        ],
                                        y: [
                                            -0.025,
                                            -0.025
                                        ]
                                    },
                                    t: 10,
                                    s: [
                                        120,
                                        120
                                    ]
                                },
                                {
                                    t: 11.9988879887247,
                                    s: [
                                        100,
                                        100
                                    ]
                                }
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.976470589638,
                        0.654901981354,
                        0.46274510026,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.167,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            },
            {
                ty: "fl",
                c: {
                    a: 0,
                    k: [
                        1,
                        0.96862745285,
                        0.921568632126,
                        1
                    ],
                    ix: 4,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                bm: 0,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
            }
        ],
        ip: 5.00000020365417,
        op: 898.00003657629,
        st: 5.00000020365417,
        bm: 0
    },
    {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: "Fill",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 15.0000006109625,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    233,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.96862745285,
                                0.921568632126,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 1.00000004073083,
        op: 902.000036739213,
        st: 2.00000008146167,
        bm: 0
    }
];
var markers = [];
var Target = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Target as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Target.json.es.js.map
